var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "22",
      "height": "13",
      "viewBox": "0 0 22 5",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.0388 4.91832C1.75309 4.91832 0.772461 3.93769 0.772461 2.63018C0.772461 1.32993 1.76761 0.349304 3.08964 0.349304C3.92499 0.349304 4.63686 0.748819 5.03637 1.35899C5.08722 1.45342 5.05816 1.55512 4.94921 1.58417L4.65865 1.69313C4.62959 1.7004 4.61507 1.70766 4.58601 1.70766C4.51337 1.70766 4.43347 1.67134 4.38988 1.60597C4.09933 1.21371 3.63444 0.974002 3.08238 0.974002C2.14534 0.974002 1.43347 1.68587 1.43347 2.63018C1.43347 3.57449 2.12355 4.29363 3.00974 4.29363C3.75792 4.29363 4.39715 3.79968 4.54969 3.08055H3.09691C2.99522 3.08055 2.90805 2.99338 2.90805 2.89169V2.64471C2.90805 2.54301 2.99522 2.46311 3.09691 2.46311H5.09448C5.19618 2.46311 5.28334 2.55028 5.28334 2.64471C5.29061 3.93043 4.32451 4.91832 3.0388 4.91832Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.9662 0.341919C10.2664 0.341919 11.2543 1.32254 11.2543 2.63005C11.2543 3.93028 10.2664 4.91091 8.9662 4.91091C7.66596 4.91091 6.68533 3.93028 6.68533 2.63005C6.68533 1.32254 7.66596 0.341919 8.9662 0.341919ZM8.9662 4.28621C9.88145 4.28621 10.5715 3.57435 10.5715 2.63005C10.5715 1.68574 9.88145 0.966617 8.9662 0.966617C8.05095 0.966617 7.36088 1.67848 7.36088 2.63005C7.36088 3.57435 8.05095 4.28621 8.9662 4.28621Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.9758 0.421814H13.2591C13.3608 0.421814 13.4407 0.501717 13.4407 0.603412V4.2281H15.5908C15.6925 4.2281 15.7797 4.31527 15.7797 4.41696V4.64941C15.7797 4.7511 15.6925 4.831 15.5908 4.831H12.9758C12.8741 4.831 12.787 4.7511 12.787 4.64941V0.603412C12.787 0.501717 12.8669 0.421814 12.9758 0.421814Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.1889 0.603412C17.1889 0.501717 17.2761 0.421814 17.3778 0.421814H18.9468C20.247 0.421814 21.2349 1.38065 21.2349 2.62278C21.2349 3.86491 20.247 4.831 18.9468 4.831H17.3778C17.2761 4.831 17.1889 4.7511 17.1889 4.64941V0.603412ZM17.8427 1.03198V4.2281H18.9468C19.862 4.2281 20.5521 3.53076 20.5521 2.63004C20.5521 1.73658 19.862 1.03198 18.9468 1.03198H17.8427Z",
      "fill": "white"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }